// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { SvgContainer } from 'common/styles/oc-styled-components';

// Other
import { colors } from 'common/styles/style-constants';

// Component
const RibbonSvg = ({ height, margin, width }) => (
  <SvgContainer
    color={colors.white}
    height={height}
    margin={margin}
    width={width}
  >
    <svg
      width="24"
      height="33"
      viewBox="0 0 24 33"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      <g fillRule="evenodd">
        <path d="M15.415 22.418c-.415 0-.83-.093-1.246-.233-.37.372-.83.65-1.293.79-1.2.372-2.446.047-3.277-.79l-.092-.093-.093.047c-.37.138-.784.23-1.2.23-.923 0-1.753-.37-2.307-1.02-.23-.234-.554-.234-.74.045L.093 28.413c-.23.326 0 .744.37.79l3.184.186c.185 0 .37.14.416.325l1.153 2.974c.14.37.6.418.83.092l5.447-7.53c.185-.278.6-.278.785 0l5.446 7.53c.23.326.692.233.83-.093l1.155-2.975c.046-.186.23-.28.415-.326l3.185-.186c.37 0 .6-.465.37-.79l-5.078-7.02c-.185-.23-.554-.278-.738-.045-.647.65-1.523 1.068-2.447 1.068M21.14 11.774l.737-.744c.323-.325.323-.93 0-1.255l-.692-.697c-.277-.28-.323-.65-.185-.976l.37-.93c.184-.464 0-.975-.462-1.16l-.97-.42c-.323-.14-.553-.464-.553-.836V3.733c0-.51-.416-.883-.877-.883h-.97c-.37 0-.692-.232-.83-.558l-.37-.93c-.184-.464-.692-.696-1.153-.51l-1.016.418c-.324.14-.693.046-.97-.186L12.462.34c-.323-.325-.923-.325-1.247 0l-.692.697c-.277.28-.646.326-.97.186L8.632.85c-.46-.184-.968 0-1.153.466l-.415.976c-.14.326-.462.558-.83.558H5.168c-.508 0-.878.418-.878.883v.976c0 .37-.23.696-.553.836l-.925.372c-.46.186-.692.697-.507 1.162l.415.976c.14.325.046.697-.184.976l-.74.743c-.323.326-.323.93 0 1.255l.692.698c.277.278.323.65.185.976l-.37.93c-.184.464 0 .975.462 1.16l.97.42c.322.14.552.464.552.836v1.07c0 .51.416.882.877.882h.97c.368 0 .69.233.83.558l.37.93c.183.464.69.697 1.152.51l.97-.418c.323-.14.692-.046.97.186l.737.744c.322.325.922.325 1.245 0l.693-.697c.277-.28.646-.326.97-.186L15 20c.462.187.97 0 1.154-.464l.415-.976c.138-.325.46-.558.83-.558h1.062c.507 0 .877-.418.877-.883v-.977c0-.372.23-.697.552-.837l.923-.37c.462-.187.693-.7.508-1.163l-.415-.976c-.093-.372-.046-.744.23-1.023" />
      </g>
    </svg>
  </SvgContainer>
);

RibbonSvg.propTypes = {
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default RibbonSvg;
